import React, { createContext, useEffect, useMemo, useState } from 'react';

import { type RequestService } from './../request-service-provider/request-service-provider';
import { useRequestService } from './../request-service-provider/request-service-provider';
import { type BaseUrlResponse } from './../site-pages/types';

const fetchBaseUrl = async (makeRequest: RequestService['makeRequest']): Promise<string> => {
  const response = await makeRequest(`/_api/ricos-site-pages/base-url`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });
  const json: BaseUrlResponse = await response.json();
  return typeof json?.baseUrl === 'string' ? json.baseUrl : '';
};

type ContextValue = {
  baseUrl: string;
};

export const EditorBaseUrlContext = createContext<ContextValue>({
  baseUrl: '',
});

export const EditorBaseUrlContextProvider: React.FC<
  React.PropsWithChildren<{ baseUrl?: string | undefined }>
> = ({ baseUrl, children }) => {
  const { makeRequest } = useRequestService();
  const [fetchResult, setFetchResult] = useState<string>();
  const value = useMemo(
    () => ({
      baseUrl: baseUrl ?? fetchResult ?? '',
    }),
    [baseUrl, fetchResult]
  );

  useEffect(() => {
    if (baseUrl === undefined) {
      fetchBaseUrl(makeRequest)
        .then(setFetchResult)
        .catch(error => {
          console.warn('Failed to get baseUrl', error);
        });
    }
  }, []);

  return <EditorBaseUrlContext.Provider children={children} value={value} />;
};
